














































































import {API} from '@/services/api/api';
import {Vue, Component} from 'vue-property-decorator';
import {mapGetters, mapActions} from 'vuex';
import FilterMenu from '@/components/FilterMenu.vue';
import InsapectionList from '@/components/InspectionListComponent.vue';
import ShipList from '@/models/shiplist';
import {Utils} from '@/utils/Utils';
import PDFTemplate from '@/components/template/PDFTemplate.vue';
@Component({
  components: {
    FilterMenu,
    InsapectionList,
    PDFTemplate,
  },
  //   computed: {...mapGetters(['shipList'])},
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
})
export default class ActionPlanList extends Vue {
  showErrorToast: any;
  showSuccessToast: any;
  shipId: number = null;
  dateFrom = null;
  dateUpto = null;
  inspectionList = [];
  shipImageUrl = '';
  shipName = '';
  //   shipList: ShipList;
  deckImageUrl = '';
  shipDetails = {};
  deckName = '';
  showDeleteBtns = false;
  deleteBtnLoader = false;
  isScreenLoading = true;
  componentName = 'InspectionListPage';
  printBtnLoader = false;
  showCreateBtn = Utils.manageRoutePermissions('action', 2);
  showDeleteBtn = false;
  showDeletEntireBtn = false;

  mounted() {
    this.getInspectionList();
  }

  async getInspectionList() {
    try {
      this.inspectionList = [];

      const response = await API.getInspectionList(null);
      if (response.data) {
        const data = response.data;

        let modifiedData = data.filter((me) => {
          return me.actionPlanStatus !== 'Close' && me.actionPlanStatus !== 'Open' && me.actionPlanStatus !== 'On Hold';
        });

        this.deleteBtnLoader = false;
        this.inspectionList = modifiedData;
      } else if (response.errors) {
        if (response.errors.ShipId) {
          this.showErrorToast({msg: response.errors.ShipId[0]});
        } else if (response.errors.InspectionId) {
          this.showErrorToast({msg: response.errors.InspectionId[0]});
        } else if (response.errors.FromDate) {
          this.showErrorToast({msg: response.errors.FromDate[0]});
        } else if (response.errors.ToDate) {
          this.showErrorToast({msg: response.errors.ToDate[0]});
        }
      } else {
        this.showErrorToast({msg: 'Network error'});
      }
      //
    } catch (error) {
      console.error(error);

      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }
  toggleDeleteBtns(checkBoxStatus) {
    this.showDeleteBtn = checkBoxStatus.delete;
    this.showDeletEntireBtn = checkBoxStatus.deleteEntire;
  }

  closeDeleteBtnLoader() {
    this.deleteBtnLoader = false;
  }

  onDeleteClick() {
    this.deleteBtnLoader = true;
    const inspectionComponentRef: any = this.$refs.inspectionComponentRef;
    inspectionComponentRef.onDeleteClick();
  }

  onDeleteEntireClick() {
    const inspectionComponentRef: any = this.$refs.inspectionComponentRef;
    inspectionComponentRef.onDeleteEntireClick();
  }

  goToCreatePage() {
    this.$router.push('/create-inspection');
  }

  stopBtnLoader() {
    this.printBtnLoader = false;
  }

  onPrintClick() {
    this.printBtnLoader = true;
    const ref: any = this.$refs.pdfTemplateRef;
    ref.htmlToPdf();
  }
}
